import { render, staticRenderFns } from "./NormalTable.vue?vue&type=template&id=38008c3b&scoped=true"
import script from "./NormalTable.vue?vue&type=script&lang=js"
export * from "./NormalTable.vue?vue&type=script&lang=js"
import style0 from "./NormalTable.vue?vue&type=style&index=0&id=38008c3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38008c3b",
  null
  
)

export default component.exports